import { request } from '@umijs/max';

export interface CloudStudioEntitlement {
  entitlementId: string;
  userId: string;
  tenantId: string;
  createAt?: string;
}

const BASE_URL = '/nebulith-cloudstudio-pro/v1/entitlement';

export async function getCloudStudioEntitlement(): Promise<CloudStudioEntitlement | null> {
  try {
    return await request<CloudStudioEntitlement>(`${BASE_URL}/self`, {
      method: 'POST',
      data: {},
      skipErrorHandler: true,
    });
  } catch (error) {
    const response = error as {
      response?: { status?: number; data?: { code?: string } };
      info?: { code?: string };
    };
    if (
      response.response?.status === 404 ||
      response.response?.data?.code === 'NOT_FOUND' ||
      response.info?.code === 'NOT_FOUND'
    ) {
      return null;
    }
    throw error;
  }
}

export function createCloudStudioEntitlement() {
  return request<CloudStudioEntitlement>(`${BASE_URL}/create`, {
    method: 'POST',
    data: {},
    skipErrorHandler: true,
  });
}
